import { ThreadPrimitive, useThread } from "@assistant-ui/react";
import { ArrowRight } from "lucide-react";
import type { FC } from "react";
import { useEffect, useState } from "react";

export const ThreadFollowupSuggestions: FC = () => {
  const { suggestions, isRunning } = useThread();
  const [, forceRerender] = useState(0);

  useEffect(() => {
    //TODO The alternative solution to make the suggestion re-render from the second time onward.
    if (isRunning) return;
    const timer = setTimeout(() => {
      forceRerender((x) => x + 1);
    }, 120);
    return () => clearTimeout(timer);
  }, [isRunning]);

  return (
    <ThreadPrimitive.If empty={false} running={false}>
      <div className={"mx-auto w-full max-w-4xl"}>
        <div className="flex flex-col gap-2 px-4">
          {suggestions?.map((suggestion) => (
            <ThreadPrimitive.Suggestion
              key={suggestion?.prompt}
              className="line-clamp-1 flex h-auto w-full items-center justify-between rounded-[10px] border bg-background px-3 py-1 text-start text-sm font-bold hover:bg-[#f7f7f7]"
              prompt={suggestion.prompt}
              title={suggestion?.prompt}
              method="replace"
              autoSend
            >
              {suggestion.prompt}
              <ArrowRight />
            </ThreadPrimitive.Suggestion>
          ))}
        </div>
      </div>
    </ThreadPrimitive.If>
  );
};
